// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarRefreshButton.tsx
import RefreshIcon from "@mui/icons-material/Refresh";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";

export interface DataGridToolbarRefreshButtonProps
  extends DataGridToolbarProps {}

export default function DataGridToolbarRefreshButton({
  load,
  buttonSize,
}: DataGridToolbarRefreshButtonProps) {
  return (
    <DataGridToolbarButtonContainer>
      <Tooltip title={I18n.t("App.refresh")}>
        <IconButton onClick={load} size={buttonSize}>
          <RefreshIcon fontSize={buttonSize} />
        </IconButton>
      </Tooltip>
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarRefreshButton.tsx